module.exports = "/images/vendor/flag-icon-css/flags/4x3/af.svg?008dc3229529b5e6be2aa03ce93fc03e";